import TokenService from '../token';
import { pushToDataLayer } from './utils';
import { DataLayerEvent, DataLayerEventPayload, TosPrivacyConsentScreenType } from './types';

export const pushTosPrivacyConsentGiven = (screen: TosPrivacyConsentScreenType): void => {
  const payload: DataLayerEventPayload = {
    event: DataLayerEvent.TOS_CONSENT_GIVEN,
    consentType: 'tos_privacy',
    value: true,
    screen,
    recordedAt: new Date().toISOString(),
  };

  const userId = screen === TosPrivacyConsentScreenType.MEMBER_AREA && TokenService.getUserId();
  if (userId) {
    payload.userId = userId;
  }

  pushToDataLayer(payload);
};
